import React from 'react';
import PropTypes from 'prop-types';
import FormattedListValue from '@/shared/components/FormattedListValue';
import SimplePanel from '@/shared/components/SimplePanel';
import { FormattedMessage, injectIntl } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import Checkbox from '@/shared/components/input/Checkbox';
import messages from '../jobMessages';

const JobDetailUpdateTaskStatus = ({ job, intl }) => {
  const sendEmailText = job.parameters.sendEmail
    ? intl.formatMessage(messages.Yes)
    : intl.formatMessage(messages.No);

  return (
    <SimplePanel title={<FormattedListValue list="jobType" id={job.jobType} />}>
      <div className="info-block container-fluid radius4B">
        <div className="row">
          <div className="col-lg-6">
            <div className="row">
              <div className="col-md-5 col-sm-6">
                <label>
                  <b>
                    <FormattedMessage {...messages.Task} />
                  </b>
                </label>
              </div>
              <div className="col-md-7 col-sm-6">
                <FormattedListValue
                  list="tasktemplate"
                  id={job.parameters.mainTaskTemplateId}
                  fallback={job.parameters.mainTaskName}
                />
              </div>
            </div>
            {job.parameters.subtaskTemplateId || job.parameters.subtaskName ? (
              <div className="row">
                <div className="col-md-5 col-sm-6">
                  <label>
                    <b>
                      <FormattedMessage {...messages.Subtask} />
                    </b>
                  </label>
                </div>
                <div className="col-md-7 col-sm-6">
                  <FormattedListValue
                    list="tasktemplate"
                    id={job.parameters.subtaskTemplateId}
                    fallback={job.parameters.subtaskName}
                  />
                </div>
              </div>
            ) : null}
            <div className="row">
              <div className="col-md-5 col-sm-6">
                <label>
                  <b>
                    <FormattedMessage {...messages.SendEmail} />
                  </b>
                </label>
              </div>
              <div className="col-md-7 col-sm-6">
                <Checkbox value={job.parameters.sendEmail} text={sendEmailText} />
              </div>
            </div>
          </div>
          <div className="col-lg-5">
            <div className="row">
              <div className="col-md-8 col-sm-6">
                <label>
                  <b>
                    <FormattedMessage {...messages.Status} />
                  </b>
                </label>
              </div>
              <div className="col-md-4 col-sm-6">
                {!!job.parameters.desiredStatus ? (
                  <FormattedListValue list="taskstatus" id={job.parameters.desiredStatus} />
                ) : (
                  '/'
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-md-8 col-sm-6">
                <label>
                  <b>
                    <FormattedMessage {...messages.Blocked} />
                  </b>
                </label>
              </div>
              <div className="col-md-4 col-sm-6">
                <Checkbox value={job.parameters.markAsBlocked} />
              </div>
            </div>
            <div className="row">
              <div className="col-md-8 col-sm-6">
                <label>
                  <b>
                    <FormattedMessage {...messages.Inapplicable} />
                  </b>
                </label>
              </div>
              <div className="col-md-4 col-sm-6">
                <Checkbox value={job.parameters.markAsInapplicable} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </SimplePanel>
  );
};

JobDetailUpdateTaskStatus.propTypes = {
  job: PropTypes.shape({}).isRequired,
  intl: intlShape.isRequired,
};

export default injectIntl(JobDetailUpdateTaskStatus);
